import { API_URLS } from "../../constants/api/index.js"
async function CompositeResetPassword({id ,entry,userId,mail,phone}) {

   let responseData: { retCode: number, retMsg: string } = {
      retCode: 0,
      retMsg: ""
   }
   const data = `{
      "id": "${id}",
         "entry":"${entry}",
         "userId": "${userId}",
         "mail": "${mail}",
         "phone": "${phone}"
   }`;

   var params = {
      method: 'POST',
      body:
         `{
         "id": "${id}",
         "entry":"${entry}",
         "userId": "${userId}",
         "mail": "${mail}",
         "phone": "${phone}"
      }`
         
   }

 //"https://azure-apigateway-openbanking-uat.apps.ocptest4.akbank.com/api/v1/ldapaccessbase/reset-password"
   await fetch(
      
    API_URLS.COMPOSITE1,   params    
  ).then(response => response.json())
  
      .then((textResponse) => {  
            debugger;
          responseData = {
         
            retCode: textResponse.retCode,           
             retMsg: textResponse.retMsg
          };
      })
      .catch((error) => {
      })
  return responseData;
}

export { CompositeResetPassword }


